// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgh_a bhh_wj bhh_a bhh_q bhh_k","AdSlotMail__mail--notLoaded":"bgh_b bhh_ey bhh_bj bhh_wy","show-ad-not-loaded":"bgh_c","AdSlotMail__cta":"bgh_e"};